module.exports = __webpack_public_path__ + "static/media/logo.1c7705e2.svg";